import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { RichTextEditorComponent } from "../fields/rich-text-editor/rich-text-editor.component";
import { InputFormFieldComponent } from "../fields/input-form-field/input-form-field.component";
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-write-article-form',
  standalone: true,
  imports: [RichTextEditorComponent, InputFormFieldComponent, TranslateModule, ReactiveFormsModule, CommonModule],
  templateUrl: './write-article-form.component.html',
  styleUrl: './write-article-form.component.scss'
})
export class WriteArticleFormComponent {
  @Input() form!: FormGroup;
  @Input() isViewMode: boolean = false;

  ngOnChanges(): void {
    if (this.isViewMode) {
      this.form.get('articleContent')?.disable(); 
    } else {
      this.form.get('articleContent')?.enable();  
    }
  }
}
